// extracted by mini-css-extract-plugin
module.exports = {"contactRelation":"index-module_contactRelation_1Cbc0"};